<div class="row mb-3 d-none d-lg-flex">
    <div class="col-2 text-center">
        <label
            for="sourceVerifiedNoChange"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_VERIFIED_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceClassificationName"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceMaterialNumber"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceCalibrationDate"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL"
        ></label>
    </div>
</div>

@if (model.sourceReplacements?.value?.length === 0) {
    <div class="text-center">
        <span translate="CONFIRMATION_SOURCE_REPLACEMENTS_NOT_AVAILABLE"></span>
    </div>
}

<div [formGroup]="sourceReplacementsForm">
    @for (sourceReplacement of model.sourceReplacements.value; track sourceReplacement; let i = $index) {
        <fieldset>
            <div
                class="row gap-2 gap-lg-0 mb-3"
                [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'highlight-deleted-controls' : ''"
            >
                <div class="col-12 d-lg-none d-flex">
                    @if (sourceReplacement.changeIndicatorCode === deleteCode) {
                        <span
                            class="fst-italic d-flex"
                            translate="CONFIRMATION_SOURCE_REPLACEMENTS_DELETED_RECORD"
                        ></span>
                    }
                    <button
                        type="button"
                        id="btnDelete"
                        class="btn ms-auto"
                        [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'btn-success' : 'btn-warning'"
                        (click)="deleteSourceReplacement(sourceReplacement, i)"
                        [attr.aria-label]="('CONFIRMATION_SOURCE_REPLACEMENTS_DELETE_ARIA_LABEL' | translate) + (i + 1)"
                    >
                        @if (sourceReplacement.changeIndicatorCode !== deleteCode) {
                            <fa-icon [icon]="faTrash"></fa-icon>
                        }
                        @if (sourceReplacement.changeIndicatorCode === deleteCode) {
                            <fa-icon [icon]="faTrashRestore"></fa-icon>
                        }
                    </button>
                </div>
                <div
                    class="col-12 col-lg-2 mt-2 mt-lg-0 text-center d-flex justify-content-lg-center align-items-start gap-2"
                >
                    @if (!sourceReplacement.isNewEntry) {
                        <label
                            class="col-form-label d-flex d-lg-none"
                            [attr.for]="'sourceVerifiedNoChange-' + i"
                            translate="CONFIRMATION_SOURCE_REPLACEMENTS_VERIFIED_LABEL"
                        ></label>
                        <pace-core-checkbox-input
                            class="align-child-center"
                            [id]="'sourceVerifiedNoChange-' + i"
                            [(model)]="sourceReplacement.changeIndicator"
                            (valueChange)="changeIndicatorChanged(sourceReplacement)"
                            [parentForm]="sourceReplacementsFormChildren"
                        ></pace-core-checkbox-input>
                    }
                </div>
                <div class="col-12 col-lg-3">
                    <label
                        for="sourceClassificationName"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="sourceClassificationName"
                        [(model)]="sourceReplacement.sourceClassification"
                        [parentForm]="sourceReplacementsFormChildren"
                        [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-12 col-lg-3">
                    <label
                        for="sourceMaterialNumber"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="sourceMaterialNumber"
                        [(model)]="sourceReplacement.materialNumber"
                        [parentForm]="sourceReplacementsFormChildren"
                        [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-12 col-lg-3">
                    @if (
                        !sourceReplacement.changeIndicator.value && sourceReplacement.changeIndicatorCode !== deleteCode
                    ) {
                        <label
                            for="sourceCalibrationDate"
                            class="col-form-label d-lg-none"
                            translate="CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL"
                        ></label>
                        <pace-core-date-input
                            id="sourceCalibrationDate"
                            [(model)]="sourceReplacement.calibrationDate"
                            (valueChange)="calibrationDateChanged(sourceReplacement)"
                            [parentForm]="sourceReplacementsFormChildren"
                            [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL' | translate"
                        >
                        </pace-core-date-input>
                    }

                    @if (sourceReplacement.changeIndicatorCode === deleteCode) {
                        <span
                            class="fst-italic d-none d-lg-block pt-1"
                            translate="CONFIRMATION_SOURCE_REPLACEMENTS_DELETED_RECORD"
                        ></span>
                    }
                </div>
                <div class="col-lg-1 d-none d-lg-block">
                    <button
                        type="button"
                        id="btnDelete"
                        class="btn"
                        [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'btn-success' : 'btn-warning'"
                        (click)="deleteSourceReplacement(sourceReplacement, i)"
                        [attr.aria-label]="('CONFIRMATION_SOURCE_REPLACEMENTS_DELETE_ARIA_LABEL' | translate) + (i + 1)"
                    >
                        @if (sourceReplacement.changeIndicatorCode !== deleteCode) {
                            <fa-icon [icon]="faTrash"></fa-icon>
                        }
                        @if (sourceReplacement.changeIndicatorCode === deleteCode) {
                            <fa-icon [icon]="faTrashRestore"></fa-icon>
                        }
                    </button>
                </div>
                <hr class="separator d-block d-lg-none" />
            </div>
        </fieldset>
    }
</div>
<hr class="separator d-none d-lg-block" />
<div class="row">
    <div class="col-12 d-flex justify-content-lg-end gap-2 align-items-center">
        @if (activeSourceReplacements() >= maxSourceReplacements) {
            <span class="fst-italic" translate="CONFIRMATION_SOURCE_REPLACEMENTS_MAX_LIMIT_REACHED"></span>
        }
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="activeSourceReplacements() >= maxSourceReplacements"
            (click)="addSourceReplacement()"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_ADD_LABEL"
        ></button>
    </div>
</div>
